export enum RlCmControlsPopouChipValues {
    Risks = 1,
    CmObervations = 2,
}
